import React from 'react';
import { useTranslation } from 'react-i18next';
import LessonStepsUI from "./LessonStepsUI";
import KeyboardNavigateLesson from './KeyboardNavigateLesson'; 
import SideBarPanelNav from "components/SideBarPanelNav/SideBarPanelNav";
import Animal from "components/Animal/Animal";
import "./LessonPanel.scss"
const LessonPanel = ({
    currentLessonRecipe,
    stepsRecipe,
    StepProgIndex,
    setStepProgIndex,
    CurrentSelectedStep,
    CurrentLessonIndex,
    LessonProgIndex,
    handleOpenLobby,
    setCurrentSelectedStep,
    setCurrentSelectedStepItem,
    FadeOutContent,
    MaxSteps,
    handleOpenStepper,
    stepName,
    stepDescription,
    StepNumberToShow,
    coinName,
    stepRequirements,
    StepRequirement,
    AnimalType,
    imageToShow,
    AnimalName,
    lessonStepsProgress,
    lessonHasMandatoryProgress,
    }) => {
    const {t} = useTranslation();
  
    
    const calcStepState = (stepIndex) => {
        if(LessonProgIndex > CurrentLessonIndex){
            return 'completed'
        } else if (StepProgIndex > stepIndex) {
            return 'completed';
        } else if (!lessonHasMandatoryProgress) {
            // Only notMandatory items (e.g. intro video) have been completed — don't unlock real steps
            return 'disabled';
        } else if (StepProgIndex === stepIndex) {
            return 'enabled';
        } else {
            return 'disabled';
        }
    };

    KeyboardNavigateLesson(CurrentSelectedStep, setCurrentSelectedStep,( (LessonProgIndex > CurrentLessonIndex) ? MaxSteps-1 : StepProgIndex), handleOpenStepper)
    
    const tapOnVideo = () => {
        if(calcStepState(CurrentSelectedStep) == "enabled" || calcStepState(CurrentSelectedStep) == "completed") {
            handleOpenStepper();
        }
    }
    
    const RenderStepCTA = () => {
        return (
            <>
            
            {(calcStepState(CurrentSelectedStep) === "enabled" || calcStepState(CurrentSelectedStep) === "completed") &&
                <>
                    <div onClick={handleOpenStepper} className="cursorPointer">
                        <button className={"arcadeBtn arcadeBtnLarge buttonCatbearsMinWidth340 " }>
                            <img className="icon-play_triangle" src="/assets/icons/icon-play_triangle.svg" alt="play button" />
                            {calcStepState(CurrentSelectedStep) == "completed" ? t("general.replay") : lessonHasMandatoryProgress ? t("general.continue") : t("general.start")}
                        </button>
                        <p className="buttonSmallText displayNone">👉 {t("general.firstNeedToCompletePreviousActivity")}</p>
                    </div>
                </>
            }
            {(calcStepState(CurrentSelectedStep) != "enabled" && calcStepState(CurrentSelectedStep) != "completed") &&
                    <div className="cursorPointer">
                        <button  className={"buttonCatbears arcadeBtn buttonCatbearsMinWidth340 buttonCatbears_CTA buttonCatbears_disabled" }>
                            <img className="icon-play_triangle" src="/assets/icons/icon-play_triangle.svg" alt="play button" />
                            {t("general.start")}
                        </button>
                          <p className="buttonSmallText">👉 {t("general.firstNeedToCompletePreviousActivity")}</p>
                    </div>
                
            }
        </>
        )
    }
    
    return (
      <>
        <div className={"Lesson  " }>

            <div className={"Lesson--side-a noselect " + (FadeOutContent ? "fadeOutSlow" : "")}>
                <SideBarPanelNav
                    left1={'backButton'}
                    leftTo={'/theatre'}
                    right={'lobby'}
                    rightAction={handleOpenLobby}
                    center={'twoLinesTopSubTitle'}
                    centerTitle={t(currentLessonRecipe.name)}
                />
                <LessonStepsUI 
                  stepsRecipe={stepsRecipe} 
                  calcStepState={calcStepState} 
                  CurrentSelectedStep={CurrentSelectedStep}
                  setCurrentSelectedStep={setCurrentSelectedStep}
                  handleOpenStepper={handleOpenStepper}
                />
                <div className="LessonDetails-MOBILE " >
                    <div className="LessonDetails-MOBILE__top ">
                        <div className="step-details--text">
                            <div className="step-details--text__side-a">
                                <div className="step-details--name">{stepsRecipe[CurrentSelectedStep].StepNumberToShow && stepsRecipe[CurrentSelectedStep].StepNumberToShow + "."} {stepName}</div>
                                <div className="step-details--description">{stepDescription}</div>
                            </div>
                        </div>
                        <div className="lesson-video-thumbnail" >
                            <img className="lesson-video-thumbnail__img" src={stepsRecipe[CurrentSelectedStep].videoThumbnail} alt="video thumbnail" />
                        </div>
                    </div>
                    <RenderStepCTA />
                </div>
            </div>
            <div className={"Lesson--side-b noselect " + (FadeOutContent ? "fadeOutSlow" : "")}>
                <div className="lesson-video--container " onClick={tapOnVideo}>
                    
                    <div className={"lesson-video-thumbnail " + ((calcStepState(CurrentSelectedStep) != "enabled" && calcStepState(CurrentSelectedStep) != "completed") ?  " lesson-video-thumbnail-no-play-button" : "")}>
                        <img className="lesson-video-thumbnail__img" src={stepsRecipe[CurrentSelectedStep].videoThumbnail} alt="video thumbnail" />
                        <div className="step-details ">
                            <div className="step-details--b noselect ">
                                <div className="step-details--container">
                                {(stepRequirements || !stepRequirements == null) ?
                                <>
                                    <div className="stepRequirements--title">{t("general.prepForStep")}</div>
                                    <div className="stepRequirements--container">
                                    {stepRequirements.map((Requirement, index) => {
                                        return (
                                            <StepRequirement
                                            key={index}
                                            type={Requirement.name}
                                            
                                            />
                                        )
                                    })}
                                    </div>
                                </>
                                : <div className="step-details--b-spacer">lala</div>
                                }
                                </div>
                            </div>
                            <div className="step-details--a noselect ">
                                    {coinName && 
                                        <div className="step-details--coin">
                                            <img className={"step-details--coin-img" } src={"/assets/coins/coin_" + coinName + "_on.svg"} alt={coinName} />  
                                        </div>
                                    }
                                    {AnimalName && 
                                        <div className="step-details--imageToShow">
                                            <Animal id={AnimalName} alt="my animal" />
                                        </div>
                                    }
                                    {imageToShow && 
                                        <div className="step-details--imageToShow">
                                            <img src={imageToShow} alt="image" />
                                        </div>
                                    }
                                    {StepNumberToShow && <div className={"step-details--number " + (calcStepState(CurrentSelectedStep) === "enabled" ? "step-details--number-enabled " : "") + (calcStepState(CurrentSelectedStep) === "completed" ? "step-details--number-completed " : "")}>{StepNumberToShow}</div>}
                                <div className="step-details--a-top">
                                    <div className="step-details--a-end ">
                                        <div className="step-details--name">{stepName}</div>
                                        <div className="step-details--description">{stepDescription}</div>
                                    </div>
                                </div>
                                <div className="step-details--a-bottom">
                                    <RenderStepCTA />
                                </div>
                            
                            </div>
                                
                                <div className="step-details--background"></div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>  
      </>)
  }

export default LessonPanel;
